import { useMutation } from '@apollo/react-hooks';

import { gerarNovaSenhaMutation } from '../components/ForgotPassword/query';

import { GerarNovaSenhaFuncionarioMutation, MutationGerarNovaSenhaFuncionarioArgs } from 'types/graphql';

export function usePassword() {
  const [gerarSenha, { data, error, loading }] = useMutation<
    { gerarNovaSenhaFuncionario: GerarNovaSenhaFuncionarioMutation },
    MutationGerarNovaSenhaFuncionarioArgs
  >(gerarNovaSenhaMutation);

  async function onSubmit(email: string) {
    await gerarSenha({
      variables: { emailFuncionario: email },
    });
  }

  return {
    onSubmit,
    error,
    loading,
  };
}
